import type { ReactNode } from 'react';

/** Branded, welcoming shell for login / register / reset screens. */
export function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex min-h-full flex-col items-center justify-center bg-cream px-4 py-10">
      <div className="w-full max-w-md">
        <div className="overflow-hidden rounded-lg shadow-card">
          <div className="bg-grove px-6 py-6 text-center">
            <img
              src="/brand/logo.png"
              alt="Lost Grove Brewing"
              className="mx-auto h-12 w-auto"
              width={382}
              height={152}
            />
            <div className="mt-2 font-display text-3xl uppercase tracking-wide text-amber">
              Pick&nbsp;’Em
            </div>
          </div>
          <div className="bg-surface px-6 py-6">
            <h1 className="font-display text-3xl uppercase text-ink">{title}</h1>
            {subtitle && <p className="mb-4 mt-1 text-sm text-muted">{subtitle}</p>}
            {!subtitle && <div className="mb-4" />}
            {children}
          </div>
        </div>
        {footer && <div className="mt-4 text-center text-sm text-muted">{footer}</div>}
      </div>
    </div>
  );
}
